module.exports = __webpack_public_path__ + "media/images/countryrect/in-c0ebf8d92e1ef29d9b19061fc6f8ad7c.svg";